import React, { useEffect, useState } from 'react';
import { SocketCallback } from '../../components/room/types';
import { ErrorMessageModal } from '../../modals/ErrorMessageModal';

type PropTypes = {
  socketCallbackResponse?: SocketCallback;
};

export const SocketCallbackHandler = ({
  socketCallbackResponse,
}: PropTypes) => {
  const [errorMessage, setErrorMessage] = useState<string>();
  const [openErrorMessageModal, setOpenErrorMessageModal] = useState(false);

  useEffect(() => {
    if (!socketCallbackResponse) return;
    if (
      socketCallbackResponse.status === 'failed' &&
      socketCallbackResponse.message === 'Player not found'
    ) {
      setOpenErrorMessageModal(true);
      setErrorMessage('Please refresh this page');
      return;
    }
    if (socketCallbackResponse.status === 'failed') {
      setOpenErrorMessageModal(true);
      setErrorMessage(socketCallbackResponse.message || 'Error occurred');
      return;
    }
  }, [socketCallbackResponse]);

  return (
    <ErrorMessageModal
      errorMessage={errorMessage || 'unknown'}
      openErrorMessageModal={openErrorMessageModal}
      setOpenErrorMessageModal={setOpenErrorMessageModal}
    ></ErrorMessageModal>
  );
};
